export function scrollTable(value) {
  document
    .querySelector('table.p-datatable-scrollable-table')
    .scrollIntoView(value);
}
